import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Chip from '@material-ui/core/Chip'
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import MoreIcon from '@material-ui/icons/MoreVert';
import { useHistory, useLocation } from "react-router-dom";
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HelpIcon from '@material-ui/icons/Help';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import serviceRest from '../../../services/serviceRest'
import { useSelector } from "react-redux";

import DirectionsBikeIcon from '@material-ui/icons/DirectionsBike';
import DateRangeIcon from '@material-ui/icons/DateRange';
import PeopleIcon from '@material-ui/icons/People';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import FormatListNumberedIcon from '@material-ui/icons/FormatListNumbered';
import StorageIcon from '@material-ui/icons/Storage';
import HistoryIcon from '@material-ui/icons/History';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import LocationCityIcon from '@material-ui/icons/LocationCity';
import ExtensionIcon from '@material-ui/icons/Extension';
import SettingsIcon from '@material-ui/icons/Settings';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import PersonIcon from '@material-ui/icons/Person';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import DescriptionIcon from '@material-ui/icons/Description';
import MapIcon from '@material-ui/icons/Map';
import InsertInvitationIcon from '@material-ui/icons/InsertInvitation';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

const componentsIcons = {
    directionsBikeIcon: DirectionsBikeIcon,
    dateRangeIcon: DateRangeIcon,
    peopleIcon: PeopleIcon,
    shoppingCartIcon: ShoppingCartIcon,
    accountBalanceWalletIcon: AccountBalanceWalletIcon,
    descriptionIcon: DescriptionIcon,
    accessibilityNewIcon: AccessibilityNewIcon,
    formatListNumberedIcon: FormatListNumberedIcon,
    storageIcon: StorageIcon,
    historyIcon: HistoryIcon,
    emojiPeopleIcon: EmojiPeopleIcon,
    locationCityIcon: LocationCityIcon,
    extensionIcon: ExtensionIcon,
    settingsIcon: SettingsIcon,
    menuBookIcon: MenuBookIcon,
    eventAvailableIcon: EventAvailableIcon,
    showChartIcon: ShowChartIcon,
    personIcon: PersonIcon,
    visibilityIcon: VisibilityIcon,
    meetingRoomIcon: MeetingRoomIcon,
    mapIcon: MapIcon,
    insertInvitationIcon: InsertInvitationIcon,
    attachMoneyIcon: AttachMoneyIcon,
};


const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    offset: theme.mixins.toolbar,
    logoBackend: {
        width: "6%",
        padding:"5px"
    },
    titleApp: {
        fontStyle:"italic"
    },
}));

export default function MenuBackend() {
    const userSession = useSelector(state => state.session);
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [itemMenu, setItemMenu] = useState([]);
    const isMenuOpen = Boolean(anchorEl);
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        handleMobileMenuClose();
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const handleHelp = () => {
        let url = "/service/manuel_utilisateur";
        window.open(url);
    }

    const handleLogout = () => {
        serviceRest.post('/react/user/logout', {}).then((response) => {
            console.log(response.data)
            history.push("/backend/connexion")
        }, (error) => {
            console.log(error);
        });
    }

    const handleNavigate = (hrefLocation) => {
        history.push(hrefLocation)
        handleMenuClose()
    }

    useEffect(() => {
        if ((itemMenu.length === 0) && (location.pathname.includes("/backend/"))) {
            serviceRest.get('/react/menu/getModules').then((response) => {
                setItemMenu(response.data);
            }, (error) => {
                console.log(error);
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history.location.pathname]);

    const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >

            {itemMenu.map((item, index) => {
                const Icons = componentsIcons[item.icon];
                return [
                    item.react ? <MenuItem onClick={_ => handleNavigate(item.refLocation)} key={item.key}><Icons />{item.text}</MenuItem>
                        : <a href={item.refLocation} style={{ textDecoration: "none", color: "inherit" }}><MenuItem key={item.key}><Icons />{item.text}</MenuItem></a>
                ]
            })}

            {/* {itemMenu.map((item) => (
                
                item.react ? <MenuItem onClick={_ => handleNavigate(item.refLocation)} key={item.key}>{item.text}</MenuItem>
                    : <a href={item.refLocation} style={{ textDecoration: "none", color: "inherit" }}><MenuItem key={item.key}>{item.text}</MenuItem></a>
            ))} */}
        </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            {itemMenu.map((item, index) => {
                const Icons = componentsIcons[item.icon];
                return [
                    item.react ? <MenuItem onClick={_ => handleNavigate(item.refLocation)} key={item.key}><Icons />{item.text}</MenuItem>
                        : <a href={item.refLocation} style={{ textDecoration: "none", color: "inherit" }}><MenuItem key={item.key}><Icons />{item.text}</MenuItem></a>
                ]
            })}
        </Menu>
    );

    return (
        <div className={classes.grow}>
            <AppBar elevation={!userSession.connected ? 0 : 3} position="fixed" style={{ backgroundImage: !userSession.connected ? "linear-gradient(to bottom, #424f63, #707787, #9fa2ae, #cfcfd5, #ffffff)":""}}>
                <Toolbar>
                    {userSession.connected ?
                        <>
                            <Typography className={classes.title} variant="h6" noWrap>
                                {userSession.infos.COM_UTI_LOGIN} ({userSession.infos.Lien_61.INS_NOM})
                            </Typography>
                            <div className={classes.sectionDesktop}>
                                {itemMenu.length > 1 && <IconButton
                                    edge="end"
                                    aria-label="account of current user"
                                    aria-controls={menuId}
                                    aria-haspopup="true"
                                    onClick={handleProfileMenuOpen}
                                    color="inherit"
                                >
                                    <ViewModuleIcon />
                                </IconButton>}
                            </div>
                            <div className={classes.sectionMobile}>
                                {itemMenu.length > 1 && <IconButton
                                    aria-label="show more"
                                    aria-controls={mobileMenuId}
                                    aria-haspopup="true"
                                    onClick={handleMobileMenuOpen}
                                    color="inherit"
                                >
                                    <MoreIcon />
                                </IconButton>}
                            </div>
                            {!userSession.prod && <Chip style={{ marginLeft: "10px", fontSize: "1em" }} color="secondary" label="VERSION DEMO" />}
                            <div className={classes.grow} />
                            <IconButton edge="end" className={classes.menuButton} onClick={handleHelp} color="inherit" aria-label="help">
                                <HelpIcon />
                            </IconButton>
                            {!userSession.sso ? <IconButton edge="start" className={classes.menuButton} onClick={handleLogout} color="inherit" aria-label="logout">
                                <ExitToAppIcon />
                            </IconButton> : null}
                        </>
                        :
                        <>
                            <img className={classes.logoBackend} src={userSession.softwareLogoPath} alt="logoApp"/>
                            <Typography className={classes.titleApp} variant="h6" noWrap>{userSession.softwareName}</Typography>
                        </>
                    }
                </Toolbar>
            </AppBar>
            <div className={classes.offset} />
            {renderMobileMenu}
            {renderMenu}
        </div>
    );
}
